export default {
  free_menu_items: 'Desbloqueado grátis',
  discount_badge: '{{value}} de desconto',
  available_at_badge: 'Disponível {{schedule}}',
  restricted_tooltip: 'Disponível {{schedule}} — altere o horário de levantamento acima para encomendar.',
};
